<template>
    <span>
        <el-select
            v-if="showInput"
            filterable
            class="filterItem-value"
            v-model="filterItem.value[0]"
            clearable
            @visible-change="visibleChange"
            :loading="loading"
            :filter-method="filterFun"
            placeholder="请选择">
                <el-option
                    v-for="item in options"
                    :key="item.Value"
                    :label="item.Label"
                    :value="item.Value"
                    >
                </el-option>
        </el-select>
        <el-select
            v-if="showMultSelect"
            class="filterItem-value"
            filterable
            multiple
            v-model="filterItem.value"
            collapse-tags
            collapse-tags-tooltip
            clearable
            @visible-change="visibleChange"
            :loading="loading"
            :filter-method="filterFun"
            placeholder="请选择">
                <el-option
                    v-for="item in options"
                    :key="item.Value"
                    :label="item.Label"
                    :value="item.Value"
                    >
                </el-option>
        </el-select>
    </span>
</template>

<script>
    import baseFilter from "../../BaseFilter"
    import { ChoiceOptionsDefaultType } from "../../../../common/constant"
    import { readContentItems } from "../../../../apis/httpHelper"
    import { uniqBy } from "lodash"

    export default {
        name:"SingleChoiceProFieldFilter",
        mixins:[baseFilter],
        data:function(){
            return {
                selfSetting:{},
                emptyValue:null,

                localQuery:false,
                showState:false,
                loading:false,

                reComputedOptions:false,

                options:[]
            }
        },
        filterOptionsFunc:{},
        scriptOptionsFunc:{},
        localOptions:[],
        created:function(){
            this.initFilterConfig();
        },
        methods:{
            initFilterConfig:function(){
                this.selfSetting = this.contentDefinition.Settings.SingleChoiceProFieldSetting;
                this.handleOptionsFuncScript();
                this.changeOptions();
            },
            changeOptions: function () {
                switch (this.selfSetting.ChoiceOptions.DefaultValueType) {
                    case ChoiceOptionsDefaultType.Custom:
                        this.optionCustomFun();
                        break;
                    case ChoiceOptionsDefaultType.DataLinkage:
                        this.optionRelyValueFun();
                        break;
                    case ChoiceOptionsDefaultType.RelationForm:
                        this.optionRelationFormFun();
                        break;
                    case ChoiceOptionsDefaultType.Formula:
                        this.optionFormulaExpression();
                        break;
                    default:
                        break;
                }
            },

            handleOptionsFuncScript: function () {
                switch (this.selfSetting.ChoiceOptions.DefaultValueType) {
                    case ChoiceOptionsDefaultType.Custom:
                        break;
                    case ChoiceOptionsDefaultType.DataLinkage:
                        this.filterOptionsFunc = new Function("Context", "Content", "self", this.selfSetting.ChoiceOptions.RelySettingString);
                        break;
                    case ChoiceOptionsDefaultType.RelationForm:
                        break;
                    case ChoiceOptionsDefaultType.Formula:
                        this.scriptOptionsFunc = new Function("Context", "Content", "self", this.selfSetting.ChoiceOptions.Script);
                        break;
                    default:
                        break;
                }
            },

            optionCustomFun:function(){
                let optionsResult = this.selfSetting.ChoiceOptions.CustomOptions;
                this.setOptions(optionsResult);
                this.localQuery = true;
            },

            
            optionRelyValueFun:function(filter){
                this.getRemoteOptions(filter);
            },

            optionRelationFormFun:function(filter){
                if(filter == undefined){
                    this.getRemoteOptions();
                }
                else{
                    this.getRemoteOptions(filter);
                }
            },

            optionFormulaExpression:function(){
                let context = this.buildFormContext();
                let optionsResult = this.scriptOptionsFunc(context, context.Content);
                this.setOptions(optionsResult);
                this.localQuery = true;
            },

            handlerValueWhenChangeOptions:function(){
                
            },

            setOptions:function(optionsResult){
                optionsResult = optionsResult || [];
                let error =  optionsResult.length != Array.from(new Set(optionsResult.map(x=>x.Value))).length;
                if(error){
                    console.log(this.displayName + "-" + this.name + "下拉数据异常，待选项里面包含重复的key");
                    optionsResult = uniqBy(optionsResult,"Value");
                }
                this.localOptions = optionsResult;
                this.options = optionsResult.filter(x=> true);
                this.handlerValueWhenChangeOptions();
            },

            getRemoteOptions:function(filter){
                let fields = this.selfSetting.ChoiceOptions.QueryLabel == this.selfSetting.ChoiceOptions.QueryValue? [this.selfSetting.ChoiceOptions.QueryValue]: [this.selfSetting.ChoiceOptions.QueryLabel,this.selfSetting.ChoiceOptions.QueryValue];
                readContentItems(
                    this.selfSetting.ChoiceOptions.QueryContentType,
                    fields,
                    0,
                    200,
                    undefined,
                    filter
                ).then(x=>{
                    let optionsResult = x.Result.data.map(result=> { 
                        return { 
                            "Label": result[this.selfSetting.ChoiceOptions.QueryLabel],
                            "Value": result[this.selfSetting.ChoiceOptions.QueryValue],
                        }
                    });
                    this.localQuery = optionsResult.length == x.Result.total;
                    this.setOptions(optionsResult);
                    this.loading = false;
                }).catch(x=>{
                    console.log(x);
                    console.log(this.displayName + "-" + this.name + "数据获取异常")
                })
            },

            filterFun:function(queryString){
                let self = this;
                self.loading = true;
                if(this.localQuery){
                    this.options = this.localOptions.filter(x=> x.Label.indexOf(queryString) > -1);
                    self.loading = false;
                }
                else{
                    let selffilter = {"logic":"and","filters":[{ 
                        "field":this.selfSetting.ChoiceOptions.QueryLabel,
                        "operator":"contains",
                        "value":queryString
                        }]
                    };
                    if(this.selfSetting.ChoiceOptions.DefaultValueType == ChoiceOptionsDefaultType.DataLinkage) {
                        this.optionRelyValueFun(selffilter);
                    }
                    if(this.selfSetting.ChoiceOptions.DefaultValueType == ChoiceOptionsDefaultType.RelationForm){
                        this.optionRelationFormFun(selffilter);
                    }
                }
            },

            cleanFilter:function(){
                //本地查询 不用重新赋值
                //非本地的 要求重新计算，把计算状态放到下一次打开下拉框
                if(this.localQuery){
                    this.options = this.localOptions;
                }
                else{
                    this.reComputedOptions = true;
                }
            },

            visibleChange:function(dropDownState){
                //显示下拉框
                if(dropDownState){
                    //是否重新计算下拉选项
                    if(this.reComputedOptions){
                        this.changeOptions();
                        this.reComputedOptions = false;
                    }
                }
                //隐藏下拉框
                else{
                    this.cleanFilter();
                }
            }
        }
    }
</script>